/* eslint-disable react/no-danger */
import React from "react"
import type { ReducedBlogV2ArticleType } from "types/blog-v2-types"
import { preventWidow } from "utils/preventWidow"

import { container, postsContainer } from "./AuthorPosts.css"
import { BlogArticleCardV2 } from "../../Shared/BlogArticleCard/BlogArticleCardV2"

type Props = {
  fullName: string
  authorPosts: ReducedBlogV2ArticleType[]
}

export const AuthorPosts: React.FC<Props> = ({ fullName, authorPosts }) => (
  <div className={container}>
    <h2 dangerouslySetInnerHTML={preventWidow(`Articles by ${fullName}`)} />
    <div className={postsContainer}>
      {authorPosts.map((post) => {
        return (
          <BlogArticleCardV2
            key={post.slug}
            article={post}
            desktopCols={2}
            headingSize="h3"
          />
        )
      })}
    </div>
  </div>
)
